import React, { useState, useCallback, useEffect } from 'react';
import {
  Modal,
  RadioButton,
  Tabs,
  Card,
  Thumbnail,
  Tooltip,
  Toast
} from '@shopify/polaris'
import intl from '../../../../../i18n/intl';
import _ from 'lodash'
import { reqPostSourcingSourcinConfirmList, reqPostSourcingConfirmDone } from '../../../../../api/index'
import './index.css'
const SourcingConfirmModal = ({ active, close,cancel, sourcingRecord,handleStatusEdit }) => {
  const [showToast, setShowToast] = useState(false) //是否显示toast
  const [loadingData, setLoadingData] = useState(true) //数据loading
  const [confirmList, setConfirmList] = useState([]) //confirm数据源
  const [toastText, setToastText] = useState('Success')
  const [toastError, setToastError] = useState(false)

  const initData = useCallback(async () => { // 数据初始化
    try {
      const res = await reqPostSourcingSourcinConfirmList({
        sourcing_id: sourcingRecord
      })
      const { code, data, msg } = res
      if (code === '200' || code === 200) {
        if (data){
          data.forEach((item, index) => {
            item.tabSelected = 0
            if (index === 0) {
              item.selected = 1
            } else {
              item.selected = 0
            }
          })
          setConfirmList(data)
          setTimeout(() => {
            setLoadingData(false)
          }, 800)
        }
      } else {
        setShowToast(true)
        setToastError(true)
        setToastText(msg)
      }
    } catch (error) {
    }
  }, [sourcingRecord])
  useEffect(() => {
    if (active) {
      setLoadingData(true)
      //请求接口
      initData()
    } else {
      //数据重置
      setConfirmList(confirmList => confirmList.map((item, ind) => {
        if (ind === 0) {
          return { ...item, selected: 1, tabSelected: 0 }
        } else {
          return { ...item, selected: 0, tabSelected: 0 }
        }
      }))
    }
  }, [active, initData])

  const handleDone = async () => { //Done事件
    
    try {
      const params = confirmList.filter(item => {
        return item.selected === 1
      })
      
      const req = await reqPostSourcingConfirmDone({
        sourcing_id: sourcingRecord,
        ali_product_id: params[0].id
      })

      if (req.code === '200' || req.code === 200) {
        setToastError(false)
        setToastText(intl.get('Confirmed successfully'))
        handleStatusEdit()
      } else {
        setToastError(true)
        setToastText(req.msg)
      }
      setShowToast(true)
      cancel()
    } catch (error) {

    }
  }

  const handleRadioChange = (index) => { //RadioChange事件
    let data = confirmList.map((item, ind) => {
      if (ind === index) {
        return { ...item, selected: 1 }
      } else {
        return { ...item, selected: 0 }
      }
    })
    setConfirmList(data)
  }

  const handleTabChange = (selectedTabIndex, ind) => { //handleTabChange事件
    const data = confirmList.map((item, index) => {
      if (ind === index) { 
        return { ...item, tabSelected: selectedTabIndex }
      } else {
        return { ...item, tabSelected: item.tabSelected }
      }
    })
    setConfirmList(data)
  }

  const toggleActive = useCallback(() => setShowToast((showToast) => !showToast), [])  //toastActive 事件

  const tabs = [ // tabs
    {
      id: 'all-description-1',
      content: intl.get('Description'),
      accessibilityLabel: 'Description',
      panelID: 'all-description-content-1',
    },
    {
      id: 'accepts-Variants-1',
      content: intl.get('Variants'),
      panelID: 'accepts-variants-content-1',
    },
  ]

  const fixedContent = ( // 顶部固定文案
     
      <p>
       {intl.get("The Smart Sourcing Assistant matches you with a number of items based on your sourcing request. Please select the most suitable item for confirmation and the Sourcing request will be completed automatically. If there is no match, please decline it and contact us to check again.")}
      </p>
     
  )

  const tabDescriptionContent = (desc) => { //description tab
    return <div dangerouslySetInnerHTML={{ __html: desc }}></div>
  }

  const tabVariantsContent = (variants, option_one_name, option_two_name) => { //cariantsTable tab
    return <div className='variants_content'>
      <table className='variants_table'>
        <thead>
          <tr>
            <th style={{ width: '100px' }}></th>
            {
              option_one_name && <th align='left'>{option_one_name}</th>
            }
            {
              option_two_name && <th align='left'>{option_two_name}</th>
            }
            <th align='left'>{intl.get('Cost')}</th>
          </tr>
        </thead>
        <tbody>
          {
            variants.map((item, key) => {
              return (<tr key={key}>
                <td>
                  <Thumbnail
                    source={item.sku_image}
                    alt="Black choker necklace"
                  />
                </td>
                {
                  option_one_name &&
                  <td>
                    {item.sku_option_one || ''}
                  </td>
                }
                {
                  option_two_name &&
                  <td>
                    {item.sku_option_two || ''}
                  </td>
                }
                <td>
                  {`$${item.price || ''}`}
                </td>
              </tr>)
            })
          }
        </tbody>
      </table>
    </div>
  }

  const SourcingConfirmDataContent = ( //sourcing数据列表
    confirmList.map((item, index) => {
      return <div key={index}>
        <div className='confirm_content'>
          <RadioButton
            label={(<div>
              <img src={item.pictures} alt="confirm_img" style={{ width: '72px', height: '72px' }} />
            </div>)}
            name="accounts"
            id={'confirm_' + index}
            checked={item.selected === 1}
            onChange={() => handleRadioChange(index)}
          />
          {
            item.title.length > 200 ?
              <Tooltip preferredPosition='above' content={<div style={{ background: '#F5F5F5', padding: '10px' }}>
                {item.title}
              </div>}>
                <div className='confirm_title'>
                  {
                    _.truncate(item.title, {
                      'length': 200,
                      'separator': ' '
                    })
                  }
                </div>
              </Tooltip> :
              <div className='confirm_title' style={{ marginTop: '0' }}>
                {
                  item.title
                }
              </div>
          }
          <div className='confirm_cost'>
           {intl.get("Cost")}: US$ {item.price}
          </div>
        </div>
        <div>
          <Card>
            <Tabs tabs={tabs} selected={item.tabSelected} onSelect={(e) => handleTabChange(e, index)}>
                 
                {
                  (item.tabSelected === 0) ? tabDescriptionContent(item.description) : tabVariantsContent(item.variants, item.option_one_name, item.option_two_name)
                }
                 
            </Tabs>
          </Card>
        </div>
      </div>
    })
  )

  const toastContent = showToast ? ( //toastContent
    <Toast duration={2000} content={toastText} onDismiss={toggleActive} error={toastError} />
  ) : null

  return (
    <>
      <Modal
        size='large'
        title={intl.get("Sourcing Confirm")}
        onClose={()=>cancel()}
        open={active}
        primaryAction={{
          content: intl.get('Confirm'),
          onAction: handleDone,
          disabled: loadingData,
        }}
        secondaryActions={[
          {
            content: intl.get('Decline'),
            onAction: ()=>close(),
          },
        ]}
        loading={loadingData}
      >
        <Modal.Section>
          {fixedContent}
          {SourcingConfirmDataContent}
        </Modal.Section>
      </Modal>
      {toastContent}
    </>
  );
}

export default SourcingConfirmModal;
